export const PAIDLEAVE_GET_LOCATION_DETAILS = 'PAIDLEAVE_GET_LOCATION_DETAILS'
export const PAIDLEAVE_SET_LOCATION = 'PAIDLEAVE_SET_LOCATION'

export default {
  PAIDLEAVE_GET_LOCATION_DETAILS,
  PAIDLEAVE_SET_LOCATION
}
